import {Api} from '@/core/api.js';
const api = new Api();

// initial state
const state = {
  list: [],
}

// getters
const getters = {

  getList: (state, getters, rootState) => (type) => {
    var aHotels = [];
    for( var i in state.list ){
        if( state.list[ i ].visible ) aHotels.push( state.list[ i ] );
    }
    return aHotels;
  },

  get_by_id: (state, getters, rootState) => ( id ) => {
      if( typeof state.list[ id ] !== 'undefined' ) return state.list[ id ];
      return false;
  }
  
}

// actions
const actions = {

  loadList({ commit }, event ) {

    // console.log("loadCategories() with type - "+ type);

    var path = 'hotel' + ( ( typeof event !== 'undefined' )? '/event/' + event : '' );
    return api.get( path ).then( function( response ){
        if( response.status ){
            var data = response.data;
            for( var i in data ){
                data[ i ].visible = true;
            }
            
            return commit('setList', data );
        }
    });
  },

  load_by_id( { commit }, id ) {
    var path = 'hotel/' + id ;
    return api.get( path ).then( function( response ){
        if( response.status ){
            var data = response.data;
            data.visible = true;
            
            return commit('addHotel', data );
        }
    });
  }

  
}

// mutations
const mutations = {

    setList (state, data) {
        state.list = data;
    },

    addHotel ( state, hotel ) {
        var list = { ...state.list };
        list[ hotel.id ] = hotel;

        state.list = list;
    },

    addNote( state, { id, note } ) {
        var list = { ...state.list };
        list[ id ].notes[ note.id ] = note ;

        state.list = list;
    },

    removeNote( state, { id, note } ){
        var list = { ...state.list };
        delete list[ id ].notes[ note ];

        state.list = list;
    },

    applyFilters( state, filters ) {
        var list = {...state.list};
        if( !filters ){
            for( var i in list ){
                list[ i ].visible = true;
            }
        }
        else {
            for( var i in list ){
                list[ i ].visible = false;
            }
            for( var i in list ){
                var item = list[ i ];
                // console.log( " ---- ITEM " + item.name + " --- " );
                var bFound = true;
                for( var k in filters ){
                    var item_value = ( typeof item[k] == 'object' )? item[k].id : item[k];
                    // console.log( "ITEM: " + item[k] + " - FILTER: " + filters[k] );
                    if( item.hasOwnProperty( k ) && filters[ k ] != item_value ) {
                      bFound = false;
                    }
                }

                list[ i ].visible = bFound;
                
            }
        }

        state.list = list;
    }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}